import { render, staticRenderFns } from "./courseBalance.vue?vue&type=template&id=38988185&scoped=true&"
import script from "./courseBalance.vue?vue&type=script&lang=js&"
export * from "./courseBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38988185",
  null
  
)

export default component.exports